import { createContext } from 'react'

// const Context = createContext()
const StateContext = createContext();
const DispatchContext = createContext();

export { StateContext, DispatchContext }
